import { I_PayloadGetTickets } from 'app/pages/Catalog/slice/types';
import { BaseXHR } from 'utils/axios';

export const getTicketApi = (payload: I_PayloadGetTickets) =>
  BaseXHR.$get('ticket/listing', payload);

export const getRestaurantPerformanceListApi = (data: FormData) =>
  BaseXHR.$post('b2b/v1/show/performances-by-restaurant', data);
